namespace $.$$ {

	export class $shm_hitalama_text extends $.$shm_hitalama_text {

		override flow_tokens() {
			return super.flow_tokens().map( token => {
				if( token.name !== 'code' ) return token
				const [ fence, lang, body, close, tail ] = token.chunks
				if( !fence?.includes( '\n' ) || !lang ) return token

				return {
					... token,
					chunks: [
						fence.replace( /[\r\n]+$/, '' ),
						'',
						`${ lang }\n${ body }`,
						close,
						tail,
					],
				}
			} )
		}

	}

}
